/*
    RENDERS A BLOCK OF COLOUR TO GAME DEFAULT DIMENSIONS
    Adds options to block input
*/

export default class ScreenFill extends Phaser.Graphics {
  constructor(game, colour, alpha, blockInput = true) {
    super(game);
    this.beginFill(colour, alpha);
    this.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
    this.inputEnabled = blockInput;
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/ScreenFill.js